'use client';

import { useEffect, useLayoutEffect } from 'react';

import { isWindowDefined } from '../Constants/Window';

export const useIsomorphicLayoutEffect = isWindowDefined ? useLayoutEffect : useEffect;
